import React from 'react';
import propTypes from 'prop-types';
import { Skeleton, SkeletonLine, Alert, Typography } from '@one-thd/sui-atomic-components';
import { MagicMarkdown } from '../common/MagicMarkdown';

const { bool, string } = propTypes;

export const BotResponse = ({ loading, error, response }) => {
  if (loading) {
    return (
      <Skeleton grow>
        <SkeletonLine variant="multi" numberOfLines={3} />
      </Skeleton>
    );
  }

  if (error) {
    return (
      <div className="sui-mt-3">
        <Alert status="error" headline="Something went wrong on our end">
          Please refresh the page or try again later.
        </Alert>
      </div>
    );
  }

  if (response) {
    return (
      <Typography variant="body-base" height="tight" component="div">
        <div className="bot-prompt">
          <div className="sui-mb-2">
            <Typography variant="h6">Answer</Typography>
          </div>
          <MagicMarkdown>{response}</MagicMarkdown>
        </div>
      </Typography>
    );
  }

  return null;
};

BotResponse.displayName = 'BotResponse';

BotResponse.propTypes = {
  loading: bool,
  error: bool,
  response: string
};

BotResponse.defaultProps = {
  loading: false,
  error: false,
  response: ''
};
